export class FileDetails {
    userId!:string;
    name!: string;
    progress!: number;
  }

  export class uploadDetails{
    UserId!:string;   
    AppType!:string;
    FileName!:string;
    FilePath!:string;
  }